import { Navigate } from 'react-router-dom';
import { usePermissions } from '../lib/usePermissions';
import { homePathForPerms } from '../lib/permissions';

// Route guard: render children only if the current user holds (any of) the
// required permission(s). Otherwise bounce them to a page they CAN open, so a
// comercial who types /invoices/new in the URL is sent back to /orders instead
// of reaching the invoice editor.
//
//   <RequirePerm perm="billing.create"><InvoiceCreate /></RequirePerm>
//   <RequirePerm anyOf={['orders.view','orders.create']}>...</RequirePerm>
export default function RequirePerm({ perm, anyOf, children }) {
  const { perms, loading } = usePermissions();
  if (loading) return null; // wait for role/grants before deciding
  const keys = anyOf || (perm ? [perm] : []);
  const allowed = keys.length === 0 || keys.some((k) => perms.includes(k));
  if (!allowed) return <Navigate to={homePathForPerms(perms)} replace />;
  return children;
}
